import React from 'react';

import Breadcumb from './Breadcumb';
import CallToaction from './CallToaction';
import Domestic from './Domestic';
import International from './International';

function Main() {
  return (
    <>
      <Breadcumb />
      <Domestic />
      <International />
      <CallToaction />
    </>
  );
}

export default Main;
